angular.module("kitstajm").factory("User", function ($resource) {
  return $resource(
    "api/user",
    {},
    {
      get: { method: "GET", isArray: false },
    }
  );
});
